import { Product } from "@/interfaces/domain/Product";
import { Store } from "@/interfaces/domain/Store";

export enum SortTypesEnum {
  PRICE_LOWER = "PRICE_LOWER",
  NAME_DESC = "NAME_DESC",
}

type SearchScreenProps = {
  products?: Product[];
  total?: number;
  isLoading: boolean;
  currentSearch?: string;
  onBackPress: () => void;
  handleSearch: (text: string) => void;
  onSelectSortType: (type: SortTypesEnum) => void;
};

export type GlobalSearchScreenProps = {
  stores?: Store[];
} & SearchScreenProps;

export type InStoreSearchScreenProps = {
  storeId: string;
  onLoadMore: () => void;
} & SearchScreenProps;
